import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Row, Skeleton } from "antd";
import { ReactComponent as EmptyIcon } from "../../images/empty.svg";
import PageContainer from "../../components/PageContainer";
import ContentSearch from "../blog/components/ContentSearch";
import WikiArticle from "./WikiArticle";
import { getContentPerCategoryService } from "./wiki.api";

const WikiSearchResult = (props) => {
  const { keyword } = props;

  let searchParams = {
    content: keyword,
    pageNumber: 0,
    pageSize: 200,
    sort: "DESC",
    sortKey: "id",
    type: "wiki",
  };

  const { categoryId } = useParams();

  const [loading, setLoading] = useState(false);
  const [contents, setContents] = useState([]);

  if (categoryId && categoryId.length)
    Object.assign(searchParams, { categoryId });

  useEffect(() => {
    setLoading(true);
    Object.assign(searchParams, { content: keyword });

    getContentPerCategoryService(searchParams)
      .then((res) => {
        setLoading(false);
        if (res.data.hasOwnProperty("content")) {
          setContents(res.data.content);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    // eslint-disable-next-line
  }, [keyword]);

  return (
    <PageContainer
      classNames="wrap-wiki"
      headerProps={{
        tall: true,
        content: "سامانه جامع اطلاعات حقوقی",
        children: (
          <ContentSearch
            showFilterForm={false}
            allowClear={true}
            inputName="content"
            contentType={"wiki"}
          />
        ),
        className: "wrap-wiki-header",
      }}
    >
      <Row>
        <Col span={24} style={{ marginBottom: "7rem" }}>
          <Skeleton active={true} loading={loading}>
            {contents && contents.length ? (
              <div className="legal-vocabulary">
                <div className="word-wrapper">
                  {contents.map((content, i) => (
                    <WikiArticle
                      key={content.id}
                      Id={content.id}
                      Number={i + 1}
                      Title={content.title.fields[0]}
                      VisitCount={content.visitedCount}
                      Description={content.summary.fields[0]}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className="center-flex empty">
                <EmptyIcon className="mb-20" />
                این صفحه خالی است
              </div>
            )}
          </Skeleton>
        </Col>
      </Row>
    </PageContainer>
  );
};

export default WikiSearchResult;
